import { gql } from '@apollo/client';

export const updatePromptMutation = gql`
  mutation updatePrompt($promptId: ID!, $title: String!, $description: JSON!, $coverImage: Upload) {
    updateArticle(where: { id: $promptId }, data: { title: $title, body: $description, coverImage: $coverImage }) {
      id
      title
      body
      shortDescription
      coverImage {
        id
        publicUrl
        publicUrlTransformed
        _meta {
          public_id
          height
          width
        }
      }
    }
  }
`;
